export const colours = {
  white: "#FFFFFF",
  red: "#CF021B",
  indigoDark: "#3B4BA5",
  black: "#303030",
  periwinkleBlue: "#3255F4",
  periwinkleBlueLighter: "#EAEDFD",
  periwinkleBlueMedium: "#8EA0F8",
  periwinkleBlueLight: "#C6CEFB",
  periwinkleBlueDark: "#A0A9D6",
  indigoMedium: "#5E6DBA",
  indigoMediumLight: "#C6CEFB",
  indigoLighter: "#ECEEF6",
  indigoLight: "#CCD0EA",
  grayLight: "#F4F4F4",
  grayMediumLight: "#EEEEEE",
  grayMedium: "#E0E0E0",
  grayMediumDark: "#C4C4C4",
  grayDark: "#676767",
  yellowLight: "#FEF8E3",
  violetLight: "#D8D3EC",
  violet: "#5525E4",
  greenDark: "#2E676A",
  greenLight: "#2eb8ae",
  incomeyellow: "#f4db81"
};



// WEBPACK FOOTER //
// ./src/styles/colours.js